import { URI } from '@/config/config';

export default async ({ rootState }, { payload, zoneId }) => {
  const opts = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
    },
    body: JSON.stringify(payload),
  };

  const parksResult = await fetch(`${URI}zones/${zoneId}`, opts);
  const jsonResult = await parksResult.json();

  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors);
  }

  return jsonResult;
};
